import React, { useRef } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const TestimonialCard = ({ name, text }) => (
    <div className="flex-shrink-0 w-80 md:w-96 bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col relative mt-8 mx-2">
        <div className="absolute -top-5 left-8 bg-[#008080] text-white p-3 rounded-full shadow-md">
            <Quote size={20} fill="currentColor" />
        </div>
        <p className="text-gray-600 italic mb-6 leading-relaxed text-base flex-grow">"{text}"</p>
        <div className="border-t border-gray-100 pt-4">
            <h4 className="font-bold text-[#008080] text-lg font-serif">{name}</h4>
        </div>
    </div>
);

const Testimonials = () => {
    const scrollRef = useRef(null);

    const testimonials = [
        {
            name: "Hannah M.",
            text: "Community Plus Care Services changed my life. The support I receive is incredibly personalized and respectful. They truly understand what independence means to me."
        },
        {
            name: "Sarah L.",
            text: "I feel truly heard and valued. The team goes above and beyond to ensure my son can participate in his community. They've become like family to us."
        },
        {
            name: "Noah K.",
            text: "Professional, reliable, and kind. I highly recommend their services to anyone looking for genuine care. They've helped me achieve goals I never thought possible."
        },
        {
            name: "Jessica T.",
            text: "Working with Community Plus Care has been exceptional. Their staff are well-trained, punctual, and genuinely passionate about supporting participants."
        },
        {
            name: "Michael R.",
            text: "The flexibility and understanding they show is remarkable. When my needs changed, they adapted quickly without any hassle. Truly person-centered care."
        },
        {
            name: "Emily W.",
            text: "After trying several providers, we finally found the right fit. Their communication is excellent, and my mother loves her support worker. Highly recommend!"
        },
        {
            name: "David P.",
            text: "They helped me gain confidence and skills to live more independently. The staff treat me with dignity and always respect my choices. Five stars!"
        }
    ];

    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = 400;
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section className="py-20 bg-gray-50 overflow-hidden">
            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <h2 className="text-[#D99C3B] font-serif text-4xl lg:text-5xl font-bold mb-4">What Our Clients Say</h2>
                    <div className="w-24 h-1 bg-[#008080] mx-auto rounded-full opacity-50"></div>
                </div>

                {/* Scroll Container */}
                <div className="relative">
                    {/* Left Arrow */}
                    <button
                        onClick={() => scroll('left')}
                        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-3 text-[#008080] hover:bg-[#008080] hover:text-white transition-all duration-300 hidden md:flex items-center justify-center"
                        aria-label="Scroll left"
                    >
                        <ChevronLeft size={24} />
                    </button>

                    {/* Testimonials Scroll */}
                    <div
                        ref={scrollRef}
                        className="flex overflow-x-auto scrollbar-hide pb-4 pt-6 px-4 md:px-12 snap-x snap-mandatory"
                        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                    >
                        {testimonials.map((t, index) => (
                            <div key={index} className="snap-center">
                                <TestimonialCard {...t} />
                            </div>
                        ))}
                    </div>

                    {/* Right Arrow */}
                    <button
                        onClick={() => scroll('right')}
                        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-3 text-[#008080] hover:bg-[#008080] hover:text-white transition-all duration-300 hidden md:flex items-center justify-center"
                        aria-label="Scroll right"
                    >
                        <ChevronRight size={24} />
                    </button>
                </div>

                {/* Mobile scroll hint */}
                <p className="text-center text-gray-400 text-sm mt-4 md:hidden">← Swipe to see more →</p>
            </div>
        </section>
    );
};

export default Testimonials;

